import { atom } from 'jotai';

import type { PaymentFilters } from '../../types/payment';

export const initialPaymentFilters: PaymentFilters = {
  company: '',
  classId: '',
  cpf: '',
  studentName: '',
  nossoNumero: '',
  thirdPartyCpf: '',
  thirdPartyCnpj: '',
  email: '',
  paymentMethod: 'all',
  status: 'all',
};

export const paymentFiltersAtom = atom<PaymentFilters>(initialPaymentFilters);
